import React from "react";
import { qhseBg, training } from "../../../../assets/images";
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const Training = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <SubOtherHero title="Training & Technical Support" />
      </div>

      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row">
          {/* Left Text */}
          <div className="md:w-1/2">
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {t("Training & Technical Support")}
            </p>

            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "We deliver practical training programs and on-site technical support to ensure your team works safely and efficiently. Training covers equipment operation, maintenance routines, safety procedures, and troubleshooting — all aimed at improving performance and reducing operational risks."
              )}
            </p>

            <p className="mt-6 text-[20px] font-semibold text-[#141615]">
              {t("Why Choose Us?")}
            </p>
            <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
              <li>
                {t("Certified trainers with hands-on industry experience")}
              </li>
              <li>
                {t("Tailored training programs to fit your operational needs")}
              </li>
              <li>
                {t("Ongoing technical support and troubleshooting assistance")}
              </li>
              <li>{t("Emphasis on safety and continuous improvement")}</li>
            </ul>
          </div>

          {/* Right Image */}
          <div className="md:w-1/2 grid grid-cols-1 gap-4 mt-8 md:mt-0">
            <img
              src={training}
              alt="Drill Bit 1"
              className="w-full rounded-lg shadow-md"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Training;
